import ZonedTime from "./ZonedTime";
class Timing {
    immediately;
    times;
    constructor(response) {
        this.immediately = response.immediately;
        this.times = response.times?.map(t => new ZonedTime(t));
    }
    print() {
        const items = [];
        if (this.times !== undefined) {
            const time = this.times.find((t) => t.time !== undefined);
            if (time !== undefined) {
                items.push(...time.print());
                return items.join(' ');
            }
        }
    }
}
export default Timing;
